import React from 'react';
import { ThunderIcon } from 'icons';

const BallXp = ({ ball }: { ball: number | undefined }) => (
  <div className="flex items-center gap-1 rounded-lg border-b border-b-orange-300 bg-orange-50 px-3 py-1.5 shadow-[inset_0px_2px_4px_0px_#DDCAB761]">
    <ThunderIcon />
    <span className="font-medium text-sm">
      {ball || 0}
      <span className="text-xs"> XP</span>
    </span>
  </div>
);

export default BallXp;
